export const sequence = to => [...Array(to).keys()];

export const copy = (amount, getElem) => sequence(amount).map((_, i) => getElem(i));

export const groupByAdjacent = (arr, inSameGroup) => {
  if (!arr.length) return [];

  const result = [];
  let currentGroup = [arr[0]];
  for (let i = 1, l = arr.length; i < l; i += 1) {
    const elem = arr[i];
    if (inSameGroup(elem, currentGroup[0])) {
      currentGroup.push(elem);
      continue;
    }

    result.push(currentGroup);
    currentGroup = [elem];
  }
  result.push(currentGroup);

  return result;
}